export const TARIFF_SOURCES = {
  TRANSPORT_MEANS: 'transport_means',
  ROUTE_VALIDITY: 'route_validity',
  ROUTE_VALIDITY_VEHICLE: 'route_validity_vehicle',
};

export const TARIFF_SOURCE_LABELS = {
  transport_means: 'Valor de viagem cadastrado por tipo de rodado na rota',
  route_validity: 'Valor base da vigência da rota',
  route_validity_vehicle: 'Valor do veículo na vigência da rota',
};
